import * as NS from './namespace';
import { IUser } from '@/model/security';
import { IIndicator, ISensorDevice } from '@/model/meta';

const mutations: NS.IAdministrationMutations = {
    SET_LOADING_REQUEST(state: NS.IAdministrationState): void {
        state.preloader = true;
        state.failLoading = false;
        state.usersGrid = [];
        state.indicatorsGrid = [];
        state.devicesGrid = [];
    },
    SET_LOADING_FAIL(state: NS.IAdministrationState): void {
        state.preloader = false;
        state.failLoading = true;
        state.usersGrid = [];
        state.indicatorsGrid = [];
        state.devicesGrid = [];
    },
    SET_FORM_REQUEST(state: NS.IAdministrationState): void {
        state.activeFormRequest = true;
        state.failedFormRequest = false;
    },
    SET_FORM_REQUEST_FAIL(state: NS.IAdministrationState): void {
        state.activeFormRequest = false;
        state.failedFormRequest = true;
    },
    SET_FORM_REQUEST_RESET(state: NS.IAdministrationState): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
    },

    SET_USERSGRID_LOADING_SUCCESS(state: NS.IAdministrationState, payload: IUser[]): void {
        state.preloader = false;
        state.failLoading = false;
        payload.forEach(item => {
            item['availableDevices'] = [];
        });
        state.usersGrid = payload;
    },
    SET_UPDATE_USER(state: NS.IAdministrationState, payload: IUser): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.usersGrid.findIndex(x => x.userId === payload.userId);
        state.usersGrid.splice(index, 1, payload);
    },
    SET_INSERT_USER(state: NS.IAdministrationState, payload: IUser): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        state.usersGrid.push(payload);
    },
    SET_DELETE_USER(state: NS.IAdministrationState, payload: IUser): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.usersGrid.findIndex(x => x.userId === payload.userId);
        state.usersGrid.splice(index, 1);
    },
    SET_USER_DEVICE_SUCCESS(state: NS.IAdministrationState, payload: { user: IUser, devices: ISensorDevice[]}): void {
        payload.user.availableDevices = payload.devices;
    },
    SET_USER_DEVICES_FAIL(state: NS.IAdministrationState, payload: IUser): void {
        payload.availableDevices = [];
    },
    SET_DEVICESSUBGRID_LOADING_SUCCESS(state: NS.IAdministrationState, payload: ISensorDevice[]): void {
        state.chooseDevicesData = payload;
    },


    SET_INDICATORSGRID_LOADING_SUCCESS(state: NS.IAdministrationState, payload: IIndicator[]): void {
        state.preloader = false;
        state.failLoading = false;
        state.indicatorsGrid = payload;
    },
    SET_UPDATE_INDICATOR(state: NS.IAdministrationState, payload: IIndicator): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.indicatorsGrid.findIndex(x => x.indicatorId === payload.indicatorId);
        state.indicatorsGrid.splice(index, 1, payload);
    },
    SET_INSERT_INDICATOR(state: NS.IAdministrationState, payload: IIndicator): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        state.indicatorsGrid.push(payload);
    },
    SET_DELETE_INDICATOR(state: NS.IAdministrationState, payload: IIndicator): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.indicatorsGrid.findIndex(x => x.indicatorId === payload.indicatorId);
        state.indicatorsGrid.splice(index, 1);
    },


    SET_DEVICESGRID_LOADING_SUCCESS(state: NS.IAdministrationState, payload: ISensorDevice[]): void {
        state.preloader = false;
        state.failLoading = false;
        payload.forEach(item => {
            item['availableIndicators'] = [];
        });
        state.devicesGrid = payload;
    },
    SET_INDICATORSSUBGRID_LOADING_SUCCESS(state: NS.IAdministrationState, payload: IIndicator[]): void {
        state.chooseIndicatorData = payload;
    },
    SET_DEVICES_INDICATORS_SUCCESS(state: NS.IAdministrationState, payload: { device: ISensorDevice, indicators: IIndicator[]}): void {
        payload.device.availableIndicators = payload.indicators;
    },
    SET_DEVICES_INDICATORS_FAIL( state: NS.IAdministrationState, payload: ISensorDevice & { detailsBusy: boolean; detailsFail: boolean } ): void {
        payload.availableIndicators = [];
    },
    SET_UPDATE_DEVICE(state: NS.IAdministrationState, payload: ISensorDevice): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.devicesGrid.findIndex(x => x.sensorDeviceId === payload.sensorDeviceId);
        state.devicesGrid.splice(index, 1, payload);
    },
    SET_INSERT_DEVICE(state: NS.IAdministrationState, payload: ISensorDevice): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        state.devicesGrid.push(payload);
    },
    SET_DELETE_DEVICE(state: NS.IAdministrationState, payload: ISensorDevice): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.devicesGrid.findIndex(x => x.sensorDeviceId === payload.sensorDeviceId);
        state.devicesGrid.splice(index, 1);
    },
}

/** Реализация мутаций модуля администрирования */
export default mutations;